export default __webpack_public_path__ + "static/media/2286.07a12058.png";